export enum RepresentationType {
    UnRestricted = 0,
    Tenant = 1
}
